import { bankServices } from "../../config/axios";
import {
    BANKMASTER_ADDUPDATE_SUCCESS,
    BANKMASTER_ADDUPDATE_FAILED,
    RESET_BANKMASTER_ADDUPDATE,
    LOADING_BANKMASTER_ADDUPDATE,
    BANKMASTER_ADDUPDATE_NETWORKERROR,
} from '../types/index';

const resetbankMasterAddUpdate = () => {
    return { type: RESET_BANKMASTER_ADDUPDATE };
};

const bankMasterAddUpdate = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKMASTER_ADDUPDATE });
    await bankServices
        .post("bankmasteredit", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKMASTER_ADDUPDATE_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKMASTER_ADDUPDATE_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKMASTER_ADDUPDATE_FAILED,
        payload: data
    };
}

export { resetbankMasterAddUpdate, bankMasterAddUpdate }